export default __webpack_public_path__ + "static/media/stfrancisassisi.d38d0a00.jpg";